/** Text Asset presentation constants
 * (VISTOERA_CANVAS_TEXT_ASSET_NODE_WIDER_EXPANDED_RESIZABLE_HEIGHT_AND_COPY_TEXT_ACTION_P1_V1,
 * VISTOERA_TEXT_ASSET_CANONICAL_WIDTH_AND_HOVER_NEXT_STEP_QUICK_ACTIONS_P0_V1). */

import { generationNodeCardWidth } from './generationNodeWidthPresets'

/** Same canonical shell width as `generate_creative` — collapsed and expanded. */
export const TEXT_ASSET_CARD_WIDTH_PX = generationNodeCardWidth('generate_creative')

/** @deprecated Use TEXT_ASSET_CARD_WIDTH_PX — kept for forensic reports. */
export const TEXT_ASSET_WIDTH_COLLAPSED_PX = TEXT_ASSET_CARD_WIDTH_PX

/** @deprecated Use TEXT_ASSET_CARD_WIDTH_PX — kept for forensic reports. */
export const TEXT_ASSET_WIDTH_EXPANDED_PX = TEXT_ASSET_CARD_WIDTH_PX

export const TEXT_ASSET_CONTENT_VIEWPORT_HEIGHT_FIELD = 'contentViewportHeight' as const

export const TEXT_ASSET_CONTENT_VIEWPORT_MIN_HEIGHT = 220
export const TEXT_ASSET_CONTENT_VIEWPORT_MAX_HEIGHT = 720
export const TEXT_ASSET_CONTENT_VIEWPORT_DEFAULT_HEIGHT = 280

export function clampTextAssetContentViewportHeight(value: number): number {
  return Math.min(
    TEXT_ASSET_CONTENT_VIEWPORT_MAX_HEIGHT,
    Math.max(TEXT_ASSET_CONTENT_VIEWPORT_MIN_HEIGHT, Math.round(value)),
  )
}

export function resolveTextAssetContentViewportHeight(
  raw: unknown,
): number {
  if (typeof raw === 'number' && Number.isFinite(raw) && raw > 0) {
    return clampTextAssetContentViewportHeight(raw)
  }
  return TEXT_ASSET_CONTENT_VIEWPORT_DEFAULT_HEIGHT
}
